var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("swb-query-sort-area", {
        ref: "query_model",
        attrs: {
          config: _vm.queryConfig,
          queryKey: _vm.queryKey,
          queryHandler: _vm.queryHandler,
          popupHandler: _vm.popupHandler,
          eventHandler: _vm.queryEventHanlder
        }
      }),
      _vm._v(" "),
      _vm.allAuditFlag && !_vm.applyFlag && !_vm.voucher.done
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "simple-row" }, [
              _c("div", { staticClass: "right" }, [
                _c(
                  "a",
                  {
                    staticClass: "swb-btn swb-btn-small swb-btn-primary",
                    on: {
                      click: function($event) {
                        _vm.doneVoucher()
                      }
                    }
                  },
                  [_vm._v("执行")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "swb-btn swb-btn-small swb-btn-primary",
                    on: { click: _vm.doDoneCheck }
                  },
                  [_vm._v("执行前检查处理项")]
                )
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.auditFlag && _vm.voucher.applyState == 1 && !_vm.allAuditFlag
        ? _c("div", { staticClass: "simple-row" }, [
            _c("div", { staticClass: "right" }, [
              _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small swb-btn-primary",
                  on: {
                    click: function($event) {
                      _vm.doAuditStateBatch()
                    }
                  }
                },
                [_vm._v("批量审核")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.voucher.assetType != 2
        ? _c("div", { staticClass: "tab-container small base" }, [
            _c("div", { staticClass: "tabs-nav" }, [
              _c(
                "ul",
                { staticClass: "head" },
                _vm._l(_vm.tableState, function(status) {
                  return _c(
                    "li",
                    {
                      staticClass: "head-item",
                      class: { current: status.value == _vm.checkStateValue },
                      on: {
                        click: function($event) {
                          _vm.handleTabClick(status.value)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(status.text))])]
                  )
                })
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.handleItemList, border: "" },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _vm.auditFlag
                ? _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "40",
                      align: "center",
                      fixed: "left"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tmpNo",
                  label: "系统编号",
                  width: "220",
                  fixed: ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "title", label: "设备名称", width: "200" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "catName", label: "设备分类", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "devcCatName", label: "资产分类", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "设备品牌", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "assignedStaffName",
                  label: "指派盘点人",
                  width: "100"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "checkerName",
                  label: "实际盘点人",
                  width: "100"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "checked", label: "是否已盘", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.checked
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-success" },
                              [_vm._v("已盘")]
                            )
                          : _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-danger" },
                              [_vm._v("未盘")]
                            )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "checkedDelta", label: "盘点结果", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        (rows.row.checked || _vm.voucher.state == 2) &&
                        rows.row.checkedDelta == 0
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-success" },
                              [_vm._v("正常")]
                            )
                          : (rows.row.checked || _vm.voucher.state == 2) &&
                            rows.row.checkedDelta > 0
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-danger" },
                              [_vm._v("盘盈")]
                            )
                          : (rows.row.checked || _vm.voucher.state == 2) &&
                            rows.row.checkedDelta < 0
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-danger" },
                              [_vm._v("盘亏")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.checkStateValue == 0
                ? _c("el-table-column", {
                    attrs: {
                      prop: "physicalState",
                      label: "实物状态",
                      width: "80"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.checked && rows.row.physicalState == 0
                              ? _c("span", { staticClass: "font-green" }, [
                                  _vm._v("正常")
                                ])
                              : rows.row.checked && rows.row.physicalState == -1
                              ? _c("span", [_vm._v("无实物")])
                              : rows.row.checked && rows.row.physicalState == 1
                              ? _c("span", { staticClass: "font-red" }, [
                                  _vm._v("损坏")
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "checkMemo", label: "情况描述", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "checkTime", label: "盘点时间", width: "150" }
              }),
              _vm._v(" "),
              _vm.checkStateValue == 1
                ? _c("el-table-column", {
                    attrs: {
                      prop: "checkedQuantity",
                      label: "实盘数量",
                      width: "100",
                      align: "right"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkStateValue == 1
                ? _c("el-table-column", {
                    attrs: {
                      prop: "checkedDelta",
                      label: "盘点差值",
                      width: "100",
                      align: "right"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "出库机构", width: "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.wayValue == -1 ||
                        rows.row.wayValue == -2 ||
                        rows.row.wayValue == -3 ||
                        rows.row.wayValue == -4 ||
                        rows.row.wayValue == -5
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.voucher.retailerComName))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == 2
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.theOtherComName))
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "出库仓库", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.wayValue == -1 ||
                        rows.row.wayValue == -2 ||
                        rows.row.wayValue == -3 ||
                        rows.row.wayValue == -4 ||
                        rows.row.wayValue == -5
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.voucher.warehouseName))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == 2
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.theOtherWarehouseName))
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "入库机构", width: "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.wayValue == -1 || rows.row.wayValue == -2
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.theOtherComName))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == 2 || rows.row.wayValue == 4
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.voucher.retailerComName))
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "入库仓库", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.wayValue == -1 || rows.row.wayValue == -2
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.theOtherWarehouseName))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == 2 || rows.row.wayValue == 4
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.voucher.warehouseName))
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "单据类型", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.wayValue == -1 ||
                        rows.row.wayValue == -2 ||
                        rows.row.wayValue == 2
                          ? _c("span", [_vm._v("调拨单")])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == -3 || rows.row.wayValue == -5
                          ? _c("span", [_vm._v("清除单")])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == 4
                          ? _c("span", [_vm._v("入库单")])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == -4
                          ? _c("span", [_vm._v("出库单")])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == -6
                          ? _c("span", [_vm._v("报废单")])
                          : _vm._e(),
                        _vm._v(" "),
                        rows.row.wayValue == -7
                          ? _c("span", [_vm._v("无实物")])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "doneVoucherNo",
                  label: "单据号",
                  align: "center",
                  width: "200"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "wayText", label: "实物处理", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "quantity",
                  label: "实物处理数量",
                  width: "100",
                  align: "right"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fiscalWayText",
                  label: "财务处理",
                  width: "100"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fiscalQuantity",
                  label: "财务处理数量",
                  width: "100",
                  align: "right"
                }
              }),
              _vm._v(" "),
              _vm.voucher.done
                ? _c("el-table-column", {
                    attrs: { label: "执行完毕", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.done
                              ? _c("span", { staticClass: "font-green" }, [
                                  _vm._v("已执行")
                                ])
                              : _c("span", [_vm._v("未执行")])
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.voucher.done == false
                ? _c("el-table-column", {
                    attrs: { label: "能否生成单据", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.wayValue == 2
                              ? _c("div", [
                                  rows.row.theOtherComId != null &&
                                  rows.row.theOtherWarehouseId != null
                                    ? _c("span", [_vm._v("可以生成单据")])
                                    : _c("span", [_vm._v("无法生成单据")])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            rows.row.wayValue == -2
                              ? _c("div", [
                                  rows.row.theOtherComId != null
                                    ? _c("div", [
                                        rows.row.theOtherComId !=
                                        _vm.voucher.retailerComId
                                          ? _c("span", [_vm._v("可以生成单据")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        rows.row.theOtherComId ==
                                        _vm.voucher.retailerComId
                                          ? _c("div", [
                                              rows.row.theOtherWarehouseId !=
                                              null
                                                ? _c("span", [
                                                    _vm._v("可以生成单据")
                                                  ])
                                                : _c("span", [
                                                    _vm._v("无法生成单据")
                                                  ])
                                            ])
                                          : _vm._e()
                                      ])
                                    : _c("div", [
                                        _c("span", [_vm._v("无法生成单据")])
                                      ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            rows.row.wayValue == -3 ||
                            rows.row.wayValue == 4 ||
                            rows.row.wayValue == -4 ||
                            rows.row.wayValue == -6
                              ? _c("div", [
                                  _c("span", [_vm._v("可以生成单据")])
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "审核状态", width: "100", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.auditStateMap[rows.row.auditState]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.auditFlag
                ? _c("el-table-column", {
                    attrs: { label: "操作", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.auditState == 0 &&
                            _vm.voucher.applyState == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.doAuditState(rows.row.id)
                                      }
                                    }
                                  },
                                  [_vm._v("审核")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.applyFlag
        ? _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-1-5x" },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.applyDesc,
                      callback: function($$v) {
                        _vm.applyDesc = $$v
                      },
                      expression: "applyDesc"
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint block" }, [
      _c("span", { staticClass: "title" }, [_vm._v("温馨提示")]),
      _vm._v(" "),
      _c("p", [_vm._v("执行单据只能执行审核通过的并且需执行的数据")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("申请原因")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b84370a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b84370a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceStockHandleItemAuditStateList.vue
// module id = 3219
// module chunks = 0